import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../base/LanguageSwitcher';

export default function Navigation() {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <nav className="bg-black/95 backdrop-blur-sm fixed w-full z-50 border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center">
            <a href="/" className="text-3xl font-black text-white hover:text-cyan-400 transition-all duration-300 cursor-pointer transform hover:scale-105" style={{ fontFamily: '"Orbitron", sans-serif', letterSpacing: '0.1em' }}>
              <span className="bg-gradient-to-r from-cyan-400 via-purple-500 to-pink-500 bg-clip-text text-transparent">JCB</span>
            </a>
          </div>
          
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <a href="/" className="text-white hover:text-cyan-400 px-3 py-2 text-sm font-bold uppercase tracking-wider transition-colors cursor-pointer" style={{ fontFamily: '"Rajdhani", sans-serif' }}>
                {t('navigation.home')}
              </a>
              <a href="/music" className="text-white hover:text-cyan-400 px-3 py-2 text-sm font-bold uppercase tracking-wider transition-colors cursor-pointer" style={{ fontFamily: '"Rajdhani", sans-serif' }}>
                {t('navigation.music')}
              </a>
              <a href="/about" className="text-white hover:text-cyan-400 px-3 py-2 text-sm font-bold uppercase tracking-wider transition-colors cursor-pointer" style={{ fontFamily: '"Rajdhani", sans-serif' }}>
                {t('navigation.about')}
              </a>
              <a href="/videos" className="text-white hover:text-cyan-400 px-3 py-2 text-sm font-bold uppercase tracking-wider transition-colors cursor-pointer" style={{ fontFamily: '"Rajdhani", sans-serif' }}>
                {t('navigation.videos')}
              </a>
              <a href="/contact" className="text-white hover:text-cyan-400 px-3 py-2 text-sm font-bold uppercase tracking-wider transition-colors cursor-pointer" style={{ fontFamily: '"Rajdhani", sans-serif' }}>
                {t('navigation.contact')}
              </a>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <LanguageSwitcher />
            
            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="text-white hover:text-cyan-400 p-2 cursor-pointer"
              >
                <i className={`text-xl ${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-black/95 backdrop-blur-sm border-t border-gray-800">
          <div className="px-2 pt-2 pb-3 space-y-1">
            <a href="/" className="text-white hover:text-cyan-400 block px-3 py-2 text-base font-bold uppercase tracking-wider cursor-pointer" style={{ fontFamily: '"Rajdhani", sans-serif' }}>
              {t('navigation.home')}
            </a>
            <a href="/music" className="text-white hover:text-cyan-400 block px-3 py-2 text-base font-bold uppercase tracking-wider cursor-pointer" style={{ fontFamily: '"Rajdhani", sans-serif' }}>
              {t('navigation.music')}
            </a>
            <a href="/about" className="text-white hover:text-cyan-400 block px-3 py-2 text-base font-bold uppercase tracking-wider cursor-pointer" style={{ fontFamily: '"Rajdhani", sans-serif' }}>
              {t('navigation.about')}
            </a>
            <a href="/videos" className="text-white hover:text-cyan-400 block px-3 py-2 text-base font-bold uppercase tracking-wider cursor-pointer" style={{ fontFamily: '"Rajdhani", sans-serif' }}>
              {t('navigation.videos')}
            </a>
            <a href="/contact" className="text-white hover:text-cyan-400 block px-3 py-2 text-base font-bold uppercase tracking-wider cursor-pointer" style={{ fontFamily: '"Rajdhani", sans-serif' }}>
              {t('navigation.contact')}
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}